import { useAbility } from '@shared/AccessManager'
import { secureLocalStorageGet } from '../../app/helpers'
import React from 'react'
import { Route, RouteProps } from 'react-router-dom'

interface AppRouteProps extends RouteProps {
  casl?: string
}

export function AppRoute({ casl, ...rest }: AppRouteProps) {
  const ability = useAbility()
  const role = secureLocalStorageGet('rol');

  return casl && role ? ability.can('view', casl) ? <Route {...rest} /> : <></> : <Route {...rest} />
}
